// src/config/env.config.ts
export const firebaseWebConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? '',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? '',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? '',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? '',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? '',
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID ?? '',
} as const

/** Clé VAPID Web Push (Firebase Console → Project settings → Cloud Messaging). */
export const firebaseVapidKey =
  import.meta.env.VITE_FIREBASE_VAPID_KEY?.trim() ?? ''

export const env = {
  API_URL: import.meta.env.VITE_API_URL ?? 'http://localhost:4100/api',
  KEYCLOAK_URL: import.meta.env.VITE_KEYCLOAK_URL ?? 'http://localhost:8080',
  KEYCLOAK_REALM: import.meta.env.VITE_KEYCLOAK_REALM ?? 'sphere',
  KEYCLOAK_CLIENT_ID:
    import.meta.env.VITE_KEYCLOAK_CLIENT_ID ?? 'sphere-frontend',
  ANALYTICS_DEFAULT_TENANT:
    import.meta.env.VITE_ANALYTICS_DEFAULT_TENANT ?? 'default-tenant',
  /** Config Firebase Web (FCM / Analytics) — remplir via VITE_FIREBASE_* dans .env */
  FIREBASE: firebaseWebConfig,
}
